import { createStore } from 'vuex'

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  mobileSidebarOpen: false,
  timeout: null,
}

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  toggleMobileSidebar(state) {
    state.mobileSidebarOpen = !state.mobileSidebarOpen
  },
  closeMobileSidebar(state) {
    state.mobileSidebarOpen = false
  },
  set(state, [variable, value]) {
    state[variable] = value
  }
}

export default createStore({
  state,
  mutations,
})
